import React, { useEffect, useState } from "react";
import  NodataIcon  from "@/app/csr-src/assets/icons/NODATA.svg";
import "./noData.scss";
interface msgProps {
  msg: string;
}
export default function noData(props: msgProps) {
  return (
    <div className="no-data-box">
      <NodataIcon className="mrIcon" />
      <span className="no-data-tip">{props.msg}</span>
    </div>
  );
}
